<template>
    <div class="two-side">
        <div class="small-card pointer" @click="goTo">
            <div class="small-card-img">
                <img :src="image ? image : '/assets/images/icons/image.png'">
            </div>
            <div class="small-card-desc width-62">
                <div class="small-card-desc-date">{{ formatDate() }}</div>
                <div class="small-card-desc-title">
                    <a :href="url" target="_blank">{{title}}</a>
                </div>
                <div class="small-card-desc-author" v-if="author">
                    <div class="small-card-desc-author-name">
                        {{author}}
                    </div>
                    <!-- <div class="small-card-desc-author-view">
                        <i class="icon icon-eye"></i> {{nFormatter(view, 1)}}
                    </div> -->
                </div>
                <div v-if="link" class="small-card-desc-link">
                    Link: {{link}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import {nFormatter} from '../../NumberFormatter.js'

export default {
    props: ['id','title', 'image', 'date', 'endDate','author', 'link', 'url'],
    methods: {
        formatDate() {
            var CurrentDate = moment().format();
            var dateNow = moment(CurrentDate, "YYYY-MM-DD hh:mm:ss").locale('id').format("DD");
            var dateStart = moment(this.date, "YYYY-MM-DD hh:mm:ss").locale('id').format("DD");
            var dateEnd = moment(this.endDate, "YYYY-MM-DD hh:mm:ss").locale('id').format("DD");
           
           if(dateEnd !="Invalid date")
           {
               //tidak berhari2
               //console.log(dateNow)
                if(dateNow === dateStart)
                {
                 this.closeEvent(this.id)
                } 

           }else{
                if(dateNow === dateEnd)
                {
                 this.closeEvent(this.id)
                }
              
           }    


            if(!this.endDate || this.endDate === "") {
                return moment(this.date, "YYYY-MM-DD hh:mm:ss").locale('id').format("D MMMM YYYY HH:mm");
            } else {
                var StartDate = moment(this.date, "YYYY-MM-DD hh:mm:ss");
                var EndDate = moment(this.endDate, "YYYY-MM-DD hh:mm:ss");
                return StartDate.format('D MMMM YYYY HH:mm') + ' - ' + EndDate.format("D MMMM YYYY HH:mm");
            }
        },
        closeEvent(id){

             const token = this.$cookies.get('token');
             axios.get(`/api/widget/event/`+ id, { headers: {"Authorization" : `Bearer ${token}`} })
              // axios.get(`https://www.arkadia.me/api/widget/event/`+ id, { headers: {"Authorization" : `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczpcL1wvd3d3LmFya2FkaWEubWVcL2FwaVwvbG9naW4iLCJpYXQiOjE2NTg1NTQ5NDcsIm5iZiI6MTY1ODU1NDk0NywianRpIjoiTThCbGZwNW9yT1JtOTRkWSIsInN1YiI6MSwicHJ2IjoiMjNiZDVjODk0OWY2MDBhZGIzOWU3MDFjNDAwODcyZGI3YTU5NzZmNyJ9.g7sJLd8ICC8nP58SGdgKOOhONNl7dNuZq07z3W6TBPU`} })
                .then((response) => {
                    
                    if(response.data.status ==true)
                     {
                         this.$emit('Refresh','');
                     }    
                    
                })
                .catch((error) => {

                });
            
        },
        nFormatter(num, digits) {
            return nFormatter(num, digits)
        },
        goTo() {
            const link = this.link || this.url
            const response = this.getProtocol(link)
            if(response !== '') {
                window.open(link, '_blank');
            } else {
                window.open(`http://${link}`, '_blank');
            }
        },
        getProtocol(str) {
            try {
                var u = new URL(str);
                return u.protocol.slice(0, -1);
            } catch (e) {
                return '';
            }
        }
    }
}
</script>
<style scoped>
.small-card {
    align-items: center;
    margin-bottom: 25px;
    display: flex;
}
.small-card-img {
    width: 120px;
    height: 120px;
    margin-right: 10px;
}
.small-card-img img {
    border-radius: 8px;
    width: 120px;
    height: 120px;
    object-fit: cover;
}
.small-card-desc-date {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 15px;
    color: #828282;
}
.small-card-desc-title {
    font-family: "Poppins", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #333333;
}
.small-card-desc-title a {
    color: #333333;
    font-size: 14px;
}
.small-card-desc-title a:hover {
    text-decoration: none;
}
.small-card-desc-author {
    color: #BDBDBD;
}
.small-card-desc-author-view i {
    display: block;
    margin-right: 5px;
    width: 15px;
    margin-top: 0;
}
.small-card-desc-author-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 11px;
}
.small-card-desc-author-name {
    font-family: "Poppins", sans-serif;
    font-style: italic;
    font-weight: normal;
    font-size: 11px;
    line-height: 15px;
}
.small-card-desc-link {
    font-family: "Poppins", sans-serif;
    font-style: italic;
    font-weight: normal;
    font-size: 10px;
    line-height: 15px;
    color: #EB5757;
}
.two-side{
    float: left;
    margin: 0px 0%;
}
.width-62{
    width: 62%;
}
</style>
